import { Minus, Plus } from "lucide-react";

import { brl } from "../lib/formato";

// Até aqui cabe um botão por quantidade (1, 2, 3… Todas); acima vira −/+
const MAX_BOTOES = 6;

function Opcao({ ativa, onClick, children }) {
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      className={`min-w-[40px] h-9 px-3 rounded-md border text-sm font-bold tabular-nums transition-colors ${ativa ? "bg-primary text-primary-foreground border-primary" : "border-border bg-background hover:bg-muted"}`}
    >
      {children}
    </button>
  );
}

/**
 * Produto com várias unidades iguais (3× Coca): escolhe quantas entram no
 * pagamento. `qtd` vazio = todas as que faltam.
 */
export default function SeletorQuantidade({ restantes, qtd, precoUnit, onEscolher }) {
  const atual = qtd && qtd < restantes ? qtd : restantes;
  const todas = atual >= restantes;
  const escolher = (n) => onEscolher(n >= restantes ? null : Math.max(1, n));

  return (
    <div className="mt-2 pt-2 border-t border-primary/20" onClick={(e) => e.stopPropagation()}>
      <p className="text-[11px] text-muted-foreground mb-1.5">
        Pagar quantas? <span className="font-semibold text-foreground tabular-nums">{atual} de {restantes} · {brl(precoUnit * atual)}</span>
      </p>
      {restantes <= MAX_BOTOES ? (
        <div className="flex flex-wrap gap-1.5">
          {Array.from({ length: restantes - 1 }, (_, i) => i + 1).map((n) => (
            <Opcao key={n} ativa={!todas && atual === n} onClick={() => escolher(n)}>{n}</Opcao>
          ))}
          <Opcao ativa={todas} onClick={() => escolher(restantes)}>Todas</Opcao>
        </div>
      ) : (
        <div className="flex items-center gap-1.5">
          <Opcao ativa={false} onClick={() => escolher(atual - 1)}><Minus className="w-4 h-4" /></Opcao>
          <span className="min-w-[48px] text-center text-lg font-black tabular-nums">{atual}</span>
          <Opcao ativa={false} onClick={() => escolher(atual + 1)}><Plus className="w-4 h-4" /></Opcao>
          <Opcao ativa={todas} onClick={() => escolher(restantes)}>Todas</Opcao>
        </div>
      )}
    </div>
  );
}
